import React from 'react';
import PropTypes from 'prop-types';
import { REFEREE_STATUS, DECLINE_REASON } from '../../utils/constants';

const RefereeStatus = ({ row }) => {
  const {
    refereeStatus,
    declineReason,
    extensionReason,
    declineReasonId,
    declineReasonOther,
    refereeStatusId,
    extensionReasonApprovalNote,
    additionalNotes,
  } = row.original;
  let reason = '';
  if (refereeStatusId === REFEREE_STATUS.DECLINED) {
    reason =
      declineReasonId === DECLINE_REASON.OTHER
        ? declineReasonOther
        : declineReason;
  } else if (refereeStatusId === REFEREE_STATUS.USE_EXISTING) {
    reason = additionalNotes;
  } else if (refereeStatusId === REFEREE_STATUS.EXTENSION_REQUESTED) {
    reason = extensionReason;
  } else if (refereeStatusId === REFEREE_STATUS.EXTENSION_APPROVED) {
    reason = extensionReasonApprovalNote;
  }
  if (reason && reason !== '') {
    return (
      <div>
        {refereeStatusId === REFEREE_STATUS.USE_EXISTING ? (
          <>
            {refereeStatus}
            <br />
            <b>Notes: </b>
            <span>{reason}</span>
          </>
        ) : (
          <>
            <b>{refereeStatus} : </b>
            {refereeStatusId === REFEREE_STATUS.EXTENSION_APPROVED ? (
              <>
                <br />
                <span>Reason: {extensionReason}</span>
                <br />
                <span>Approval Note: {extensionReasonApprovalNote}</span>
              </>
            ) : (
              <span>{reason}</span>
            )}
          </>
        )}
      </div>
    );
  }
  return <div>{refereeStatus}</div>;
};

RefereeStatus.propTypes = {
  row: PropTypes.object,
};

export default RefereeStatus;
